<script setup lang="ts">
  import lightIcon from '@assets/icons/theme/light.svg'
  import darkIcon from '@assets/icons/theme/dark.svg'
  import systemIcon from '@assets/icons/theme/system.svg'
  import { useTheme } from 'vuetify'
  import { ref, watch } from 'vue'
  import { usePreferredDark } from '@vueuse/core'
  import { getThemeCookie, setThemeCookie } from '@/utils/vuetify.ts'

  const vuetifyTheme = useTheme()
  const preferredDark = usePreferredDark()

  const themePreference = ref<'light' | 'dark' | 'system'>(
    getThemeCookie('theme', 'system')
  )

  const applyTheme = (preference: 'light' | 'dark' | 'system') => {
    if (preference === 'system') {
      vuetifyTheme.global.name.value = preferredDark.value ? 'dark' : 'light'
      setThemeCookie('color-scheme', preferredDark.value ? 'dark' : 'light')
    } else {
      vuetifyTheme.global.name.value = preference
      setThemeCookie('color-scheme', preference)
    }
    setThemeCookie('theme', preference)
  }

  watch(themePreference, newPreference => {
    applyTheme(newPreference)
  })

  watch(preferredDark, isDark => {
    if (themePreference.value === 'system') {
      vuetifyTheme.global.name.value = isDark ? 'dark' : 'light'
      setThemeCookie('color-scheme', isDark ? 'dark' : 'light')
    }
  })

  applyTheme(themePreference.value)
</script>

<template>
  <v-card class="mx-auto bg-login-bg" elevation="0" max-width="420">
    <v-row class="mb-5" justify="center">
      <v-col class="mb-2" cols="12">
        <div class="text-gray-100 text-body-2 mb-2">
          <i18n-t keypath="choose_color_mode" />
        </div>
        <v-btn-toggle
          v-model="themePreference"
          border
          class="d-flex justify-space-between ga-2 w-100"
          mandatory
          rounded="0"
          style="height: 82px"
        >
          <v-btn
            class="rounded-sm flex-grow-1 border-sm border-grey-700 border-opacity-100 bg-login-bg"
            height="80"
            value="dark"
          >
            <div class="d-flex flex-column align-center ga-2">
              <v-icon :icon="darkIcon" size="24" />
              <i18n-t keypath="dark" />
            </div>
          </v-btn>
          <v-btn
            class="rounded-sm flex-grow-1 border-sm border-grey-700 border-opacity-100 bg-login-bg"
            height="80"
            value="light"
          >
            <div class="d-flex flex-column align-center ga-2">
              <v-icon :icon="lightIcon" size="24" />
              <i18n-t keypath="light" />
            </div>
          </v-btn>
          <v-btn
            class="rounded-sm flex-grow-1 border-sm border-grey-700 border-opacity-100 bg-login-bg"
            height="80"
            value="system"
          >
            <div class="d-flex flex-column align-center ga-2">
              <v-icon :icon="systemIcon" size="24" />
              <i18n-t keypath="system" />
            </div>
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="12">
        <language-selector />
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped lang="scss">

</style>
